
import { Component } from '@angular/core';
import { LoaderComponent } from '@core/loading/loader/loader.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  template: `
  <router-outlet></router-outlet>
  <app-loader></app-loader>
  `,
  imports: [
    LoaderComponent,
    RouterOutlet
  ]
})
export class AppComponent { }
